/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/token';
import './types';
import '../common/location';
import './creator_details';
import './buyer';
import './client_details';
import './processing_mode';
import './tender_tag';
import './contact_details';
import '../riskevaluation/external/external';
import '../common/payment';
import './currency_exchange';
import '../common/currency';
import '../common/tipping';
import '../roster/mds';
import '../fees/models';
import '../feeplans/feeplans_model';
import '../risk-metadata-protos/risk_manager_enrollment_status';
import '../payments/attributes/model/model';
import './translated_name';
import './cash_drawer_details';
import '../bank-accounts/bank_accounts';
import '../teller/teller';
import './card_data';
import '../common/tender';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bills": {
        "nested": {
          "Tender": {
            "fields": {
              "tenderTokenPair": {
                "type": ".squareup.common.token.TokenPair",
                "id": 1,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.bills.Tender.Type",
                "id": 2,
                "rule": "optional"
              },
              "state": {
                "type": ".squareup.bills.Tender.State",
                "id": 3,
                "rule": "optional"
              },
              "stateTimestamps": {
                "type": ".squareup.bills.Tender.StateTimestamps",
                "id": 32,
                "rule": "optional"
              },
              "method": {
                "type": ".squareup.bills.Tender.Method",
                "id": 4,
                "rule": "optional"
              },
              "tenderedAt": {
                "type": ".squareup.bills.DatePair",
                "id": 5,
                "rule": "optional"
              },
              "amounts": {
                "type": ".squareup.bills.Tender.Amounts",
                "id": 6,
                "rule": "optional"
              },
              "writeOnlyLocation": {
                "type": ".squareup.common.location.GeoLocation",
                "id": 7,
                "rule": "optional"
              },
              "creatorDetails": {
                "type": ".squareup.bills.CreatorDetails",
                "id": 8,
                "rule": "optional"
              },
              "readOnlyBuyer": {
                "type": ".squareup.bills.Buyer",
                "id": 9,
                "rule": "optional"
              },
              "readOnlyReceiptNumber": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "readOnlyLastRefundableAt": {
                "type": ".squareup.bills.ISO8601Date",
                "id": 12,
                "rule": "optional"
              },
              "writeOnlyClientDetails": {
                "type": ".squareup.bills.ClientDetails",
                "id": 13,
                "rule": "optional"
              },
              "writeOnlyAllowPartialAuthorization": {
                "type": "bool",
                "id": 14,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "direction": {
                "type": ".squareup.bills.Tender.Direction",
                "id": 15,
                "rule": "optional",
                "options": {
                  "default": "PULL"
                }
              },
              "customerPresence": {
                "type": ".squareup.bills.Tender.CustomerPresence",
                "id": 16,
                "rule": "optional"
              },
              "tenderNote": {
                "type": "string",
                "id": 17,
                "rule": "optional"
              },
              "processingMode": {
                "type": ".squareup.bills.ProcessingMode",
                "id": 18,
                "rule": "optional",
                "options": {
                  "default": "ONLINE"
                }
              },
              "instrumentToken": {
                "type": "string",
                "id": 19,
                "rule": "optional"
              },
              "extraTenderDetails": {
                "type": ".squareup.bills.Tender.CompleteTenderDetails",
                "id": 21,
                "rule": "optional"
              },
              "readOnlySequentialTenderNumber": {
                "type": "string",
                "id": 22,
                "rule": "optional"
              },
              "readOnlyRefundCardPresenceRequirement": {
                "type": ".squareup.bills.Tender.RefundCardPresenceRequirement",
                "id": 23,
                "rule": "optional",
                "options": {
                  "default": "REFUND_CARD_PRESENCE_NOT_REQUIRED"
                }
              },
              "tenderTag": {
                "type": ".squareup.bills.TenderTag",
                "id": 26,
                "rule": "repeated"
              },
              "readOnlyTenderPricingMetadata": {
                "type": ".squareup.bills.Tender.TenderPricingMetadata",
                "id": 27,
                "rule": "optional"
              },
              "recurringPaymentToken": {
                "type": "string",
                "id": 28,
                "rule": "optional"
              },
              "failureDetails": {
                "type": ".squareup.bills.Tender.FailureDetails",
                "id": 29,
                "rule": "optional"
              },
              "openTicketOwner": {
                "type": ".squareup.bills.CreatorDetails",
                "id": 30,
                "rule": "optional"
              },
              "contact": {
                "type": ".squareup.bills.ContactDetails",
                "id": 31,
                "rule": "optional"
              },
              "riskEvaluationDetails": {
                "type": ".squareup.riskevaluation.external.EvaluationDetails",
                "id": 33,
                "rule": "optional"
              },
              "groupToken": {
                "type": "string",
                "id": 34,
                "rule": "optional"
              },
              "peripheralMetadata": {
                "type": ".squareup.common.payment.PeripheralMetadata",
                "id": 35,
                "rule": "optional"
              },
              "checkoutId": {
                "type": "string",
                "id": 36,
                "rule": "optional"
              },
              "referenceId": {
                "type": "string",
                "id": 37,
                "rule": "optional"
              },
              "checkoutAppId": {
                "type": "string",
                "id": 38,
                "rule": "optional"
              },
              "originatingService": {
                "type": ".squareup.bills.Tender.OriginatingService",
                "id": 39,
                "rule": "optional"
              },
              "revenueAssociationTags": {
                "type": "string",
                "id": 40,
                "rule": "repeated"
              },
              "geoLocationType": {
                "type": ".squareup.bills.Tender.GeoLocationType",
                "id": 41,
                "rule": "optional"
              },
              "buyerCurrencyExchange": {
                "type": ".squareup.bills.CurrencyExchange",
                "id": 42,
                "rule": "optional"
              },
              "offlinePaymentMetadata": {
                "type": ".squareup.bills.OfflinePaymentMetadata",
                "id": 43,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "UNKNOWN": 0,
                  "CARD": 1,
                  "CASH": 2,
                  "NO_SALE": 3,
                  "OTHER": 4,
                  "WALLET": 5,
                  "GENERIC": 6,
                  "BANK_TRANSFER": 7,
                  "ZERO_AMOUNT": 9,
                  "SQUARE_CAPITAL": 12,
                  "EXTERNAL": 13,
                  "PUSH_TENDER": 14,
                  "SQUARE_ACCOUNT": 15
                }
              },
              "State": {
                "values": {
                  "UNKNOWN_STATE": 0,
                  "LOST": 1,
                  "AWAITING_MERCHANT_TIP": 2,
                  "AWAITING_CUSTOMER_TIP": 3,
                  "AWAITING_FULFILLMENT": 5,
                  "SETTLED": 4,
                  "CANCELED": 6,
                  "FAILED": 7
                }
              },
              "StateTimestamps": {
                "fields": {
                  "settledAt": {
                    "type": ".squareup.bills.ISO8601Date",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "Method": {
                "fields": {
                  "cardTender": {
                    "type": ".squareup.bills.CardTender",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cashTender": {
                    "type": ".squareup.bills.CashTender",
                    "id": 3,
                    "rule": "optional"
                  },
                  "noSaleTender": {
                    "type": ".squareup.bills.NoSaleTender",
                    "id": 4,
                    "rule": "optional"
                  },
                  "otherTender": {
                    "type": ".squareup.bills.OtherTender",
                    "id": 5,
                    "rule": "optional"
                  },
                  "walletTender": {
                    "type": ".squareup.bills.WalletTender",
                    "id": 6,
                    "rule": "optional"
                  },
                  "readOnlyGenericTender": {
                    "type": ".squareup.bills.GenericTender",
                    "id": 7,
                    "rule": "optional"
                  },
                  "zeroAmountTender": {
                    "type": ".squareup.bills.ZeroAmountTender",
                    "id": 8,
                    "rule": "optional"
                  },
                  "bankTransfer": {
                    "type": ".squareup.bills.BankTransferTender",
                    "id": 9,
                    "rule": "optional"
                  },
                  "squareCapitalTender": {
                    "type": ".squareup.bills.SquareCapitalTender",
                    "id": 12,
                    "rule": "optional"
                  },
                  "externalTender": {
                    "type": ".squareup.bills.ExternalTender",
                    "id": 13,
                    "rule": "optional"
                  },
                  "pushTender": {
                    "type": ".squareup.bills.PushTender",
                    "id": 14,
                    "rule": "optional"
                  },
                  "squareAccountTender": {
                    "type": ".squareup.bills.SquareAccountTender",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              },
              "Amounts": {
                "fields": {
                  "tipMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "writeOnlyTaxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipPercentage": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "readOnlyReportingAmounts": {
                    "type": ".squareup.bills.Tender.Amounts.ReportingAmounts",
                    "id": 5,
                    "rule": "optional"
                  },
                  "surchargeMoney": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "autoGratuityMoney": {
                    "type": ".squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "autoGratuityPercentage": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "cardSurchargeMoney": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReportingAmounts": {
                    "fields": {
                      "processingFeeMoney": {
                        "type": ".squareup.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "processingFeeAmounts": {
                        "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ProcessingFeeAmounts": {
                        "fields": {
                          "squareProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "taxOnProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "squareProcessingFeeAmountDetails": {
                            "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails",
                            "id": 3,
                            "rule": "optional"
                          },
                          "thirdPartyFeeAmountDetail": {
                            "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "squareProcessingFeeAmountDetailList": {
                            "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails",
                            "id": 5,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "SquareProcessingFeeAmountDetails": {
                            "fields": {
                              "initialFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "initialTaxOnFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 8,
                                "rule": "optional"
                              },
                              "adjustmentFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "adjustmentFee": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "feeType": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType",
                                "id": 4,
                                "rule": "optional"
                              },
                              "feePlan": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan",
                                "id": 5,
                                "rule": "optional"
                              },
                              "taxOnProcessingFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "freeProcessingFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 7,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "AdjustmentFee": {
                                "fields": {
                                  "money": {
                                    "type": ".squareup.common.Money",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "taxOnFeeMoney": {
                                    "type": ".squareup.common.Money",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "adjustedAt": {
                                    "type": ".squareup.bills.ISO8601Date",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "FeeType": {
                                "values": {
                                  "FIXED_RATE": 0,
                                  "COST_PLUS": 1
                                }
                              },
                              "FeePlan": {
                                "fields": {
                                  "discountBasisPoints": {
                                    "type": "int64",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "interchangeCents": {
                                    "type": "int64",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "feePlanProduct": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "feePlanId": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "taxRateBasisPoints": {
                                    "type": "int64",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "ThirdPartyFeeAmountDetail": {
                            "fields": {
                              "amount": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "thirdPartyFeeEntity": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity",
                                "id": 2,
                                "rule": "optional"
                              },
                              "thirdPartyFeeServerToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "reversalDetail": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail",
                                "id": 4,
                                "rule": "optional"
                              },
                              "thirdPartyAppDetail": {
                                "type": ".squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail",
                                "id": 5,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "ThirdPartyFeeEntity": {
                                "fields": {
                                  "unitToken": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "displayName": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "unitName": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ThirdPartyFeeReversalDetail": {
                                "fields": {
                                  "linkedThirdPartyFeeServerToken": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "ThirdPartyAppDetail": {
                                "fields": {
                                  "connectAppId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "unitToken": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              },
              "Direction": {
                "values": {
                  "PULL": 1,
                  "PUSH": 2
                }
              },
              "CustomerPresence": {
                "values": {
                  "UNKNOWN_DO_NOT_SET": 0,
                  "PRESENT": 1,
                  "ONLINE": 2,
                  "PHONE": 3,
                  "RECURRING": 4
                }
              },
              "CompleteTenderDetails": {
                "fields": {
                  "receiptDisplayDetails": {
                    "type": ".squareup.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ReceiptDisplayDetails": {
                    "fields": {
                      "displaySignatureLineOnPaperReceipt": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayTipOptionsOnPaperReceipt": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tippingPreferences": {
                        "type": ".squareup.common.tipping.TippingPreferences",
                        "id": 3,
                        "rule": "optional"
                      },
                      "displayQuickTipOptions": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      },
                      "displayCustomAmount": {
                        "type": "bool",
                        "id": 5,
                        "rule": "optional"
                      },
                      "remainingTenderBalanceMoney": {
                        "type": ".squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "buyerSelectedLocale": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "buyerSignature": {
                        "type": ".squareup.common.payment.SignatureType",
                        "id": 8,
                        "rule": "optional",
                        "options": {
                          "default": "UNKNOWN"
                        }
                      },
                      "paperSignatureTipType": {
                        "type": ".squareup.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType",
                        "id": 9,
                        "rule": "optional",
                        "options": {
                          "default": "UNSET"
                        }
                      }
                    },
                    "nested": {
                      "PaperSignatureTipType": {
                        "values": {
                          "UNSET": 0,
                          "TRADITIONAL": 1,
                          "QUICK_TIP": 2,
                          "GRATUITY_FREE": 3
                        }
                      }
                    }
                  }
                }
              },
              "RefundCardPresenceRequirement": {
                "values": {
                  "REFUND_CARD_PRESENCE_NOT_REQUIRED": 1,
                  "REFUND_CARD_PRESENCE_REQUIRED": 2
                }
              },
              "TenderPricingMetadata": {
                "fields": {
                  "merchantBillingData": {
                    "type": ".squareup.roster.mds.MerchantBillingData",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pointOfSaleSubproduct": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata.PointOfSaleSubproduct",
                    "id": 2,
                    "rule": "optional"
                  },
                  "hardwareSubType": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata.HardwareSubType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "installmentsChannel": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata.InstallmentsChannel",
                    "id": 4,
                    "rule": "optional"
                  },
                  "priceAllocationAttributes": {
                    "type": ".squareup.fees.PaymentPriceAllocationAttributes",
                    "id": 5,
                    "rule": "optional"
                  },
                  "installmentsTermOption": {
                    "type": ".squareup.bills.Tender.TenderPricingMetadata.InstallmentsTermOption",
                    "id": 6,
                    "rule": "optional"
                  },
                  "feePlanProduct": {
                    "type": ".squareup.feeplans.model.FeePlanProduct",
                    "id": 7,
                    "rule": "optional"
                  },
                  "riskManagerStatus": {
                    "type": ".squareup.risk.RiskManagerEnrollmentStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "paymentAttribute": {
                    "type": ".squareup.bills.UnitPaymentAttribute",
                    "id": 9,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PointOfSaleSubproduct": {
                    "values": {
                      "SPOS": 1,
                      "APPOINTMENTS": 2,
                      "RETAIL": 3,
                      "RESTAURANTS": 4,
                      "READER_SDK": 5
                    }
                  },
                  "HardwareSubType": {
                    "values": {
                      "UNKNOWN": 1,
                      "X2": 2,
                      "T2": 3
                    }
                  },
                  "InstallmentsChannel": {
                    "values": {
                      "IC_DO_NOT_USE": 0,
                      "PREAPPROVAL": 1,
                      "INVOICES": 2,
                      "ECOMMERCE": 3
                    }
                  },
                  "InstallmentsTermOption": {
                    "values": {
                      "ITO_DO_NOT_USE": 0,
                      "PROMO_THREE_MO": 1,
                      "PROMO_SIX_MO": 2,
                      "PROMO_TWELVE_MO": 3
                    }
                  }
                }
              },
              "FailureDetails": {
                "fields": {
                  "failureReason": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OriginatingService": {
                "values": {
                  "DO_NOT_USE": 0,
                  "PAGO": 1
                }
              },
              "GeoLocationType": {
                "values": {
                  "GEO_LOCATION_TYPE_UNSET": 0,
                  "SQUARE_DEVICE_ACCESS_POINT": 1,
                  "SQUARE_DEVICE_ETHERNET_GEOIP": 2
                }
              }
            }
          },
          "OfflinePaymentMetadata": {
            "fields": {
              "clientCreatedAt": {
                "type": ".squareup.bills.ISO8601Date",
                "id": 1,
                "rule": "optional"
              },
              "uploadedAt": {
                "type": ".squareup.bills.ISO8601Date",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "UnitPaymentAttribute": {
            "fields": {
              "attribute": {
                "type": ".squareup.payments.attributes.model.AttributeTypes.AttributeType",
                "id": 1,
                "rule": "optional"
              },
              "activeValue": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "activeDurationMillis": {
                "type": "int64",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "CardTender": {
            "fields": {
              "card": {
                "type": ".squareup.bills.CardTender.Card",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyDelayCapture": {
                "type": ".squareup.bills.CardTender.DelayCapture",
                "id": 3,
                "rule": "optional"
              },
              "authorization": {
                "type": ".squareup.bills.CardTender.Authorization",
                "id": 4,
                "rule": "optional"
              },
              "emv": {
                "type": ".squareup.bills.CardTender.Emv",
                "id": 5,
                "rule": "optional"
              },
              "accountType": {
                "type": ".squareup.bills.CardTender.AccountType",
                "id": 6,
                "rule": "optional"
              },
              "readOnlySettlementDetails": {
                "type": ".squareup.bills.CardTender.SettlementDetails",
                "id": 7,
                "rule": "optional"
              },
              "allowsReauthorizationWithChanges": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              }
            },
            "nested": {
              "Card": {
                "fields": {
                  "entryMethod": {
                    "type": ".squareup.common.payment.EntryMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": ".squareup.bills.CardTender.Card.Brand",
                    "id": 2,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyFideliusToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "writeOnlyGiftCardToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "chipCardFallbackIndicator": {
                    "type": ".squareup.bills.CardTender.Card.ChipCardFallbackIndicator",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isThirdPartyGiftCard": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "writeOnlyCanSwipeChipCard": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "fingerprint": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "felicaBrand": {
                    "type": ".squareup.bills.CardTender.Card.FelicaBrand",
                    "id": 10,
                    "rule": "optional"
                  },
                  "felicaMaskedCardNumber": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "felicaSprwid": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "isAfterpayVirtualCard": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cardCoBrand": {
                    "type": ".squareup.bills.CardTender.Card.CardCoBrand",
                    "id": 14,
                    "rule": "optional"
                  },
                  "squareAccountPaymentToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Brand": {
                    "values": {
                      "UNKNOWN_BRAND": 1,
                      "VISA": 2,
                      "MASTERCARD": 3,
                      "AMERICAN_EXPRESS": 4,
                      "DISCOVER": 5,
                      "DISCOVER_DINERS": 6,
                      "JCB": 7,
                      "CHINA_UNIONPAY": 8,
                      "SQUARE_GIFT_CARD_V2": 9,
                      "INTERAC": 10,
                      "SQUARE_CAPITAL_CARD": 11,
                      "EFTPOS": 12,
                      "FELICA": 13,
                      "ALIPAY": 14,
                      "CASH_APP": 15,
                      "EBT": 16,
                      "PAYPAY": 17,
                      "AFTERPAY": 18,
                      "SQUARE_ACCOUNT_BALANCE": 19,
                      "RAKUTEN_PAY": 20,
                      "AU_PAY": 21,
                      "D_BARAI": 22,
                      "MERPAY": 23,
                      "WECHAT_PAY": 24,
                      "STORED_VALUE": 25,
                      "QUICPAY": 26,
                      "ID": 27,
                      "TRANSPORTATION_IC": 28,
                      "CASH_LOCAL": 29,
                      "LOCAL_CASH": 30
                    }
                  },
                  "ChipCardFallbackIndicator": {
                    "values": {
                      "NONE": 0,
                      "TECHNICAL": 1,
                      "SCHEME": 2,
                      "SELLER_SWIPE_EMV_CARD_OPT_IN": 3
                    }
                  },
                  "FelicaBrand": {
                    "values": {
                      "DEFAULT_FELICA_BRAND_DO_NOT_USE": 0,
                      "FELICA_ID": 1,
                      "FELICA_TRANSPORTATION": 2,
                      "FELICA_QP": 3
                    }
                  },
                  "CardCoBrand": {
                    "values": {
                      "UNKNOWN_CO_BRAND": 0,
                      "AFTERPAY_CO_BRAND": 1,
                      "CLEARPAY_CO_BRAND": 2
                    }
                  }
                }
              },
              "DelayCapture": {
                "fields": {
                  "reason": {
                    "type": ".squareup.bills.CardTender.DelayCapture.Reason",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "UNKNOWN": 0,
                      "TIP_ON_PAPER_RECEIPT": 1,
                      "REOPENABLE": 2,
                      "FULFILLMENT": 3
                    }
                  }
                }
              },
              "Authorization": {
                "fields": {
                  "authorizationCode": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authorizedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "signatureOptionalMaxMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "authorizationRecorded": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  },
                  "remainingBalanceMoney": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.bills.CardTender.Authorization.DeclineReason",
                    "id": 6,
                    "rule": "optional"
                  },
                  "signatureBehavior": {
                    "type": ".squareup.bills.CardTender.Authorization.SignatureBehavior",
                    "id": 7,
                    "rule": "optional"
                  },
                  "recurringPaymentToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "pinToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeclineReason": {
                    "values": {
                      "DEFAULT_DO_NOT_USE": 0,
                      "CHIP_CARD_INSERTION_REQUIRED": 1,
                      "INVALID_PIN": 2,
                      "ALLOWABLE_PIN_TRIES_EXCEEDED": 3
                    }
                  },
                  "SignatureBehavior": {
                    "values": {
                      "DEFAULT_SIG_BEHAVIOR_DO_NOT_USE": 0,
                      "ISSUER_REQUEST_FOR_SIGNATURE": 1
                    }
                  }
                }
              },
              "Emv": {
                "fields": {
                  "readOnlyEncryptedEmvData": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "writeOnlyProcessingType": {
                    "type": ".squareup.bills.CardTender.Emv.ProcessingType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "readOnlyChipCardApplicationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "writeOnlyReaderFirmwareVersion": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "writeOnlyHardwareSerialNumber": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "readOnlyPlaintextEmvData": {
                    "type": "bytes",
                    "id": 6,
                    "rule": "optional"
                  },
                  "isEmvCapableReaderPresent": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "readOnlyApplicationPreferredName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "readOnlyCardholderVerificationMethodUsed": {
                    "type": ".squareup.bills.CardTender.Emv.CardholderVerificationMethod",
                    "id": 10,
                    "rule": "optional"
                  },
                  "readOnlyChipCardPreferredLanguageCode": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "buyerSelectedAccountName": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "readOnlyChipCardApplicationTransactionCounter": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "readOnlyChipCardApplicationPrimaryAccountNumberSequenceNumber": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "readOnlyAuthorizationResponseCode": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "readOnlyPtagIssuerPinRequest": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ProcessingType": {
                    "values": {
                      "UNKNOWN": 0,
                      "NOT_PROCESSED": 1,
                      "APPROVED_BY_READER_OFFLINE": 2
                    }
                  },
                  "CardholderVerificationMethod": {
                    "values": {
                      "DEFAULT_CVM_DO_NOT_USE": 0,
                      "NO_CVM": 1,
                      "SIGNATURE": 2,
                      "PIN": 3,
                      "PIN_AND_SIGNATURE": 4,
                      "ON_DEVICE": 5
                    }
                  }
                }
              },
              "AccountType": {
                "values": {
                  "UNKNOWN_ACCOUNT_TYPE": 0,
                  "SAVINGS": 1,
                  "CHECKING": 2,
                  "CREDIT": 3,
                  "EBT_CASH": 4,
                  "EBT_FOOD": 5
                }
              },
              "SettlementDetails": {
                "fields": {
                  "settlementToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "settlementCreatedAt": {
                    "type": ".squareup.bills.ISO8601Date",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "OtherTender": {
            "fields": {
              "otherTenderType": {
                "type": ".squareup.bills.OtherTender.OtherTenderType",
                "id": 1,
                "rule": "optional"
              },
              "tenderNote": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "readOnlyTranslatedName": {
                "type": ".squareup.bills.TranslatedName",
                "id": 3,
                "rule": "optional"
              },
              "externalMetadata": {
                "type": ".squareup.bills.ExternalMetadata",
                "id": 4,
                "rule": "optional"
              },
              "source": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "sourceId": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "OtherTenderType": {
                "values": {
                  "UNKNOWN": 0,
                  "CHECK": 1,
                  "MERCHANT_GIFT_CARD": 2,
                  "DEBIT": 3,
                  "CREDIT_OR_DEBIT": 4,
                  "E_MONEY": 5,
                  "DEBIT_OR_CREDIT": 6,
                  "THIRD_PARTY_CARD": 7,
                  "MEAL_VOUCHER": 8,
                  "HACKWEEK_CRYPTO": 9,
                  "HOUSE_ACCOUNT": 10,
                  "VENMO": 11,
                  "BITCOIN": 12,
                  "STORED_VALUE": 13,
                  "CUSTOM": 100
                }
              }
            }
          },
          "ExternalMetadata": {
            "fields": {
              "contentType": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "metadata": {
                "type": "bytes",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "GenericTender": {
            "fields": {
              "readOnlySettledBySquare": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "NoSaleTender": {
            "fields": {}
          },
          "CashTender": {
            "fields": {
              "amounts": {
                "type": ".squareup.bills.CashTender.Amounts",
                "id": 1,
                "rule": "optional"
              },
              "cashDrawerDetails": {
                "type": ".squareup.bills.CashDrawerDetails",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Amounts": {
                "fields": {
                  "buyerTenderedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "WalletTender": {
            "fields": {}
          },
          "ZeroAmountTender": {
            "fields": {}
          },
          "BankTransferTender": {
            "fields": {
              "squareBankAccount": {
                "type": ".squareup.bank_accounts.SquareBankAccount",
                "id": 1,
                "rule": "optional"
              },
              "counterpartyBankAccount": {
                "type": ".squareup.bills.BankTransferTender.CounterpartyBankAccount",
                "id": 2,
                "rule": "optional"
              },
              "appearsOnStatementAs": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "clientMetadata": {
                "type": ".squareup.teller.ClientMetadata",
                "id": 4,
                "rule": "optional"
              },
              "readOnlyTellerMoneyTransferToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "tenderStateDetail": {
                "type": ".squareup.bills.BankTransferTender.TenderStateDetail",
                "id": 6,
                "rule": "optional"
              },
              "failureReason": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.bills.BankTransferTender.Type",
                "id": 8,
                "rule": "optional"
              }
            },
            "nested": {
              "CounterpartyBankAccount": {
                "fields": {
                  "bankAccountInstrumentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tellerBankAccount": {
                    "type": ".squareup.teller.BankAccount",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TenderStateDetail": {
                "fields": {
                  "sentState": {
                    "type": ".squareup.teller.SentState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failedState": {
                    "type": ".squareup.teller.FailedState",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Type": {
                "values": {
                  "BANK_ACCOUNT": 0,
                  "BANK_TRANSFER": 1
                }
              }
            }
          },
          "SquareCapitalTender": {
            "fields": {
              "secretKey": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "repaymentInstrument": {
                "type": ".squareup.bills.SquareCapitalTender.CardInstrumentDetails",
                "id": 2,
                "rule": "optional"
              },
              "downPaymentAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "CardInstrumentDetails": {
                "fields": {
                  "instrumentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardholderName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "card": {
                    "type": ".squareup.bills.CardTender.Card",
                    "id": 3,
                    "rule": "optional"
                  },
                  "expirationDate": {
                    "type": ".squareup.bills.CardData.KeyedCard.Expiry",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "ExternalTender": {
            "fields": {
              "paymentSource": {
                "type": ".squareup.bills.ExternalTender.PaymentSource",
                "id": 1,
                "rule": "optional"
              }
            },
            "nested": {
              "PaymentSource": {
                "fields": {
                  "applicationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "applicationName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "PushTender": {
            "fields": {
              "entryMethod": {
                "type": ".squareup.common.payment.EntryMethod",
                "id": 2,
                "rule": "optional"
              },
              "serverCompletedVersion": {
                "type": ".squareup.common.tender.ServerCompleted.ServerCompletedVersion",
                "id": 6,
                "rule": "optional"
              },
              "cashAppTender": {
                "type": ".squareup.bills.CashAppTender",
                "id": 1
              },
              "alipayTender": {
                "type": ".squareup.bills.AlipayTender",
                "id": 3
              },
              "paypayTender": {
                "type": ".squareup.bills.PaypayTender",
                "id": 4
              },
              "afterpayTender": {
                "type": ".squareup.bills.AfterpayTender",
                "id": 5
              },
              "rakutenPayTender": {
                "type": ".squareup.bills.RakutenPayTender",
                "id": 7
              },
              "auPayTender": {
                "type": ".squareup.bills.AuPayTender",
                "id": 8
              },
              "dBaraiTender": {
                "type": ".squareup.bills.DBaraiTender",
                "id": 9
              },
              "merpayTender": {
                "type": ".squareup.bills.MerpayTender",
                "id": 10
              },
              "wechatPayTender": {
                "type": ".squareup.bills.WechatPayTender",
                "id": 11
              },
              "localCashTender": {
                "type": ".squareup.bills.LocalCashTender",
                "id": 12
              }
            },
            "nested": {
              "push_type": {
                "oneof": ["cashAppTender", "alipayTender", "paypayTender", "afterpayTender", "rakutenPayTender", "auPayTender", "dBaraiTender", "merpayTender", "wechatPayTender", "localCashTender"]
              }
            }
          },
          "CashAppTender": {
            "fields": {
              "authorizationCode": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "pwcTransactionId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "readOnlyCashtag": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "readOnlyBuyerFullName": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "AlipayTender": {
            "fields": {
              "alipayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyReferenceBuyerId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "PaypayTender": {
            "fields": {
              "paypayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyBuyerId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "RakutenPayTender": {
            "fields": {
              "rakutenPayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "AuPayTender": {
            "fields": {
              "auPayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "DBaraiTender": {
            "fields": {
              "dBaraiTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "MerpayTender": {
            "fields": {
              "merpayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "WechatPayTender": {
            "fields": {
              "wechatPayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "LocalCashTender": {
            "fields": {
              "pwcTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "AfterpayTender": {
            "fields": {
              "afterpayTransactionId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "readOnlyBuyerEmail": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "readOnlyIsClearpayBranded": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "SquareAccountTender": {
            "fields": {
              "squareAccountToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "contactToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "primaryDisplayName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bills?.nested?.Tender && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.State && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.StateTimestamps && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Method && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.AdjustmentFee && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeeType && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeePlan && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyFeeEntity && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyFeeReversalDetail && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Amounts?.nested?.ReportingAmounts?.nested?.ProcessingFeeAmounts?.nested?.ThirdPartyFeeAmountDetail?.nested?.ThirdPartyAppDetail && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.Direction && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.CustomerPresence && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails?.nested?.ReceiptDisplayDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.CompleteTenderDetails?.nested?.ReceiptDisplayDetails?.nested?.PaperSignatureTipType && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.RefundCardPresenceRequirement && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.TenderPricingMetadata && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.TenderPricingMetadata?.nested?.PointOfSaleSubproduct && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.TenderPricingMetadata?.nested?.HardwareSubType && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.TenderPricingMetadata?.nested?.InstallmentsChannel && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.TenderPricingMetadata?.nested?.InstallmentsTermOption && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.FailureDetails && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.OriginatingService && !$root.nested?.squareup?.nested?.bills?.nested?.Tender?.nested?.GeoLocationType && !$root.nested?.squareup?.nested?.bills?.nested?.OfflinePaymentMetadata && !$root.nested?.squareup?.nested?.bills?.nested?.UnitPaymentAttribute && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Card && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.Brand && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.ChipCardFallbackIndicator && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.FelicaBrand && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Card?.nested?.CardCoBrand && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.DelayCapture && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.DelayCapture?.nested?.Reason && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Authorization && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Authorization?.nested?.DeclineReason && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Authorization?.nested?.SignatureBehavior && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Emv && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Emv?.nested?.ProcessingType && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.Emv?.nested?.CardholderVerificationMethod && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.AccountType && !$root.nested?.squareup?.nested?.bills?.nested?.CardTender?.nested?.SettlementDetails && !$root.nested?.squareup?.nested?.bills?.nested?.OtherTender && !$root.nested?.squareup?.nested?.bills?.nested?.OtherTender?.nested?.OtherTenderType && !$root.nested?.squareup?.nested?.bills?.nested?.ExternalMetadata && !$root.nested?.squareup?.nested?.bills?.nested?.GenericTender && !$root.nested?.squareup?.nested?.bills?.nested?.NoSaleTender && !$root.nested?.squareup?.nested?.bills?.nested?.CashTender && !$root.nested?.squareup?.nested?.bills?.nested?.CashTender?.nested?.Amounts && !$root.nested?.squareup?.nested?.bills?.nested?.WalletTender && !$root.nested?.squareup?.nested?.bills?.nested?.ZeroAmountTender && !$root.nested?.squareup?.nested?.bills?.nested?.BankTransferTender && !$root.nested?.squareup?.nested?.bills?.nested?.BankTransferTender?.nested?.CounterpartyBankAccount && !$root.nested?.squareup?.nested?.bills?.nested?.BankTransferTender?.nested?.TenderStateDetail && !$root.nested?.squareup?.nested?.bills?.nested?.BankTransferTender?.nested?.Type && !$root.nested?.squareup?.nested?.bills?.nested?.SquareCapitalTender && !$root.nested?.squareup?.nested?.bills?.nested?.SquareCapitalTender?.nested?.CardInstrumentDetails && !$root.nested?.squareup?.nested?.bills?.nested?.ExternalTender && !$root.nested?.squareup?.nested?.bills?.nested?.ExternalTender?.nested?.PaymentSource && !$root.nested?.squareup?.nested?.bills?.nested?.PushTender && !$root.nested?.squareup?.nested?.bills?.nested?.CashAppTender && !$root.nested?.squareup?.nested?.bills?.nested?.AlipayTender && !$root.nested?.squareup?.nested?.bills?.nested?.PaypayTender && !$root.nested?.squareup?.nested?.bills?.nested?.RakutenPayTender && !$root.nested?.squareup?.nested?.bills?.nested?.AuPayTender && !$root.nested?.squareup?.nested?.bills?.nested?.DBaraiTender && !$root.nested?.squareup?.nested?.bills?.nested?.MerpayTender && !$root.nested?.squareup?.nested?.bills?.nested?.WechatPayTender && !$root.nested?.squareup?.nested?.bills?.nested?.LocalCashTender && !$root.nested?.squareup?.nested?.bills?.nested?.AfterpayTender && !$root.nested?.squareup?.nested?.bills?.nested?.SquareAccountTender) {
  $root.addJSON(jsonData);
}

/**
 * Context around how an instrument is used as part of a bill.
 *
 * For example, say a bill contains "credit card X swiped for $10". "Credit card X"
 * is the instrument and "swiped" and "$10" are tender details.
 *
 * Tenders should avoid duplicating information present in the instrument
 * whenever possible. Examples of incorrect leaks are including the PAN suffix
 * or brand in the tender, when they're inherent characteristics of the instrument.
 *
 * SOURCE Tender @ squareup/bills/tender.proto at 45:1
 */
export const Tender = $root.lookupType('squareup.bills.Tender');
fixType(Tender);
Builder.createAndAttachToType(Tender);
/**
 * SOURCE Type @ squareup/bills/tender.proto at 49:3
 */
Tender.Type = $root.lookupEnum('squareup.bills.Tender.Type').values;
/**
 * Only tenders in these states are visible to merchant:
 * - LOST
 * - AWAITING_MERCHANT_TIP
 * - AWAITING_CUSTOMER_TIP
 * - SETTLED
 *
 * SOURCE State @ squareup/bills/tender.proto at 100:3
 */
Tender.State = $root.lookupEnum('squareup.bills.Tender.State').values;
/**
 * Timestamps for when a given state was entered.
 * A given timestamp will only be present if a tender has entered or passed through the
 * corresponding state. See State enum docs for per state documentation.
 *
 * SOURCE StateTimestamps @ squareup/bills/tender.proto at 137:3
 */
Tender.StateTimestamps = $root.lookupType('squareup.bills.Tender.StateTimestamps');
fixType(Tender.StateTimestamps);
Builder.createAndAttachToType(Tender.StateTimestamps);
/**
 * The populated tender method should match the type specified in type.
 * Only one field should be populated.
 *
 * SOURCE Method @ squareup/bills/tender.proto at 151:3
 */
Tender.Method = $root.lookupType('squareup.bills.Tender.Method');
fixType(Tender.Method);
Builder.createAndAttachToType(Tender.Method);
/**
 * Note that amounts here indicate that the tender will be charged (e.g. debit for bank accounts, charge
 * for payment card). Amounts should be positive.
 *
 * SOURCE Amounts @ squareup/bills/tender.proto at 183:3
 */
Tender.Amounts = $root.lookupType('squareup.bills.Tender.Amounts');
fixType(Tender.Amounts);
Builder.createAndAttachToType(Tender.Amounts);
/**
 * SOURCE ReportingAmounts @ squareup/bills/tender.proto at 210:5
 */
Tender.Amounts.ReportingAmounts = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts');
fixType(Tender.Amounts.ReportingAmounts);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts);
/**
 * This is the breakdown for processing_fee_money.
 * processing_fee_money = square_processing_fee_money + tax_on_processing_fee_money
 *
 * SOURCE ProcessingFeeAmounts @ squareup/bills/tender.proto at 218:7
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts);
/**
 * Additional breakdown of square_processing_fee_money. Set when a tender has fee adjustment.
 * The field is used for Cost+ as of 2016 Q3.
 *
 * The following invariant holds:
 *   initial_fee_money + sum(adjustment_fee_money) = square_processing_fee_money.
 *   intial_tax_on_fee_money + sum(adjustment_tax_on_fee_money) = tax_on_processing_fee_money
 *
 * SOURCE SquareProcessingFeeAmountDetails @ squareup/bills/tender.proto at 232:9
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails);
/**
 * An AdjustmentFee is composed of a fee, and a tax on the fee.
 * The total adjusted fee including tax is (money + tax_on_fee_money).
 * Tax on fee adjustments are only used for Cost+ AU as of Q4 2020.
 *
 * SOURCE AdjustmentFee @ squareup/bills/tender.proto at 259:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.AdjustmentFee);
/**
 * Type of the fee.
 *
 * SOURCE FeeType @ squareup/bills/tender.proto at 286:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType = $root.lookupEnum('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeeType').values;
/**
 * SOURCE FeePlan @ squareup/bills/tender.proto at 294:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.SquareProcessingFeeAmountDetails.FeePlan);
/**
 * The breakdown of *non-Square* fees assessed on this tender.
 *
 * SOURCE ThirdPartyFeeAmountDetail @ squareup/bills/tender.proto at 333:9
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail, {
  amount: {
    required: true
  },
  thirdPartyFeeEntity: {
    required: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail);
/**
 * Description of the entity that is the recipient of the above fee amount.
 *
 * SOURCE ThirdPartyFeeEntity @ squareup/bills/tender.proto at 343:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity, {
  unitToken: {
    notEmpty: true
  },
  displayName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeEntity);
/**
 * For reversal third party fees, contains a pointer to the original third party fee.
 *
 * SOURCE ThirdPartyFeeReversalDetail @ squareup/bills/tender.proto at 364:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail, {
  linkedThirdPartyFeeServerToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyFeeReversalDetail);
/**
 * For third party fees derived from app fees, the app developer's information. Populated by beemo.
 *
 * SOURCE ThirdPartyAppDetail @ squareup/bills/tender.proto at 370:11
 */
Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail = $root.lookupType('squareup.bills.Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail');
fixType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail);
Builder.createAndAttachToType(Tender.Amounts.ReportingAmounts.ProcessingFeeAmounts.ThirdPartyFeeAmountDetail.ThirdPartyAppDetail);
/**
 * The direction that money moves between Square and the funding source.
 *
 * Charging a credit card is pulling money, whereas crediting a bank account or sending money
 * to a debit card via OCT is pushing.
 *
 * SOURCE Direction @ squareup/bills/tender.proto at 448:3
 */
Tender.Direction = $root.lookupEnum('squareup.bills.Tender.Direction').values;
/**
 * Customer presence at time of the tender being added.
 *
 * SOURCE CustomerPresence @ squareup/bills/tender.proto at 464:3
 */
Tender.CustomerPresence = $root.lookupEnum('squareup.bills.Tender.CustomerPresence').values;
/**
 * Extra tender details populated in CompleteTender for bill completion requests by client and copied
 * into Bill.Tender as-is by Omnibus.
 *
 * SOURCE CompleteTenderDetails @ squareup/bills/tender.proto at 516:3
 */
Tender.CompleteTenderDetails = $root.lookupType('squareup.bills.Tender.CompleteTenderDetails');
fixType(Tender.CompleteTenderDetails);
Builder.createAndAttachToType(Tender.CompleteTenderDetails);
/**
 * Used to generate duplicate receipts for re-printing and settling delayed tips.
 *
 * SOURCE ReceiptDisplayDetails @ squareup/bills/tender.proto at 518:5
 */
Tender.CompleteTenderDetails.ReceiptDisplayDetails = $root.lookupType('squareup.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails');
fixType(Tender.CompleteTenderDetails.ReceiptDisplayDetails);
Builder.createAndAttachToType(Tender.CompleteTenderDetails.ReceiptDisplayDetails);
/**
 * SOURCE PaperSignatureTipType @ squareup/bills/tender.proto at 552:7
 */
Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType = $root.lookupEnum('squareup.bills.Tender.CompleteTenderDetails.ReceiptDisplayDetails.PaperSignatureTipType').values;
/**
 * Whether card presence is required for this tender to be refunded. If REQUIRED, then
 * the card needs to be presented to Register in order to request the refund.
 *
 * Default should be REFUND_CARD_PRESENCE_NOT_REQUIRED.
 *
 * SOURCE RefundCardPresenceRequirement @ squareup/bills/tender.proto at 597:3
 */
Tender.RefundCardPresenceRequirement = $root.lookupEnum('squareup.bills.Tender.RefundCardPresenceRequirement').values;
/**
 * Some of the metadata required for pricing.
 *
 * If not present, means the pricing for the SquareProduct applies.  SquareProduct and EntryMethod
 * (or PayWithSquareEntryMethod), Country, Currency, and Unit or Merchant token or boths could
 * logically go here, except they already have places in payment records and ledger entries, etc.
 *
 * SOURCE TenderPricingMetadata @ squareup/bills/tender.proto at 621:3
 */
Tender.TenderPricingMetadata = $root.lookupType('squareup.bills.Tender.TenderPricingMetadata');
fixType(Tender.TenderPricingMetadata);
Builder.createAndAttachToType(Tender.TenderPricingMetadata);
/**
 * "Subproduct" of REGISTER (aka Point of Sale).
 *
 * SOURCE PointOfSaleSubproduct @ squareup/bills/tender.proto at 631:5
 */
Tender.TenderPricingMetadata.PointOfSaleSubproduct = $root.lookupEnum('squareup.bills.Tender.TenderPricingMetadata.PointOfSaleSubproduct').values;
/**
 * Types of Square custom hardware that run POS apps
 *
 * SOURCE HardwareSubType @ squareup/bills/tender.proto at 647:5
 */
Tender.TenderPricingMetadata.HardwareSubType = $root.lookupEnum('squareup.bills.Tender.TenderPricingMetadata.HardwareSubType').values;
/**
 * For Capital tenders, the channel in which the buyer applies for and obtains the installment
 *
 * SOURCE InstallmentsChannel @ squareup/bills/tender.proto at 658:5
 */
Tender.TenderPricingMetadata.InstallmentsChannel = $root.lookupEnum('squareup.bills.Tender.TenderPricingMetadata.InstallmentsChannel').values;
/**
 * For Capital tenders, the term length of the installment loan. Used to determine fees,
 * if determination through price_allocation_spec is unavailable.
 *
 * SOURCE InstallmentsTermOption @ squareup/bills/tender.proto at 676:5
 */
Tender.TenderPricingMetadata.InstallmentsTermOption = $root.lookupEnum('squareup.bills.Tender.TenderPricingMetadata.InstallmentsTermOption').values;
/**
 * If the charge failed for this tender, provide details on the failure
 *
 * SOURCE FailureDetails @ squareup/bills/tender.proto at 715:3
 */
Tender.FailureDetails = $root.lookupType('squareup.bills.Tender.FailureDetails');
fixType(Tender.FailureDetails);
Builder.createAndAttachToType(Tender.FailureDetails);
/**
 * Originating Payment Service for the Tender.
 *
 * SOURCE OriginatingService @ squareup/bills/tender.proto at 764:3
 */
Tender.OriginatingService = $root.lookupEnum('squareup.bills.Tender.OriginatingService').values;
/**
 * Type of geolocation method used for the tender
 *
 * SOURCE GeoLocationType @ squareup/bills/tender.proto at 784:3
 */
Tender.GeoLocationType = $root.lookupEnum('squareup.bills.Tender.GeoLocationType').values;
/**
 * SOURCE OfflinePaymentMetadata @ squareup/bills/tender.proto at 807:1
 */
export const OfflinePaymentMetadata = $root.lookupType('squareup.bills.OfflinePaymentMetadata');
fixType(OfflinePaymentMetadata);
Builder.createAndAttachToType(OfflinePaymentMetadata);
/**
 * SOURCE UnitPaymentAttribute @ squareup/bills/tender.proto at 818:1
 */
export const UnitPaymentAttribute = $root.lookupType('squareup.bills.UnitPaymentAttribute');
fixType(UnitPaymentAttribute);
Builder.createAndAttachToType(UnitPaymentAttribute);
/**
 * SOURCE CardTender @ squareup/bills/tender.proto at 835:1
 */
export const CardTender = $root.lookupType('squareup.bills.CardTender');
fixType(CardTender);
Builder.createAndAttachToType(CardTender);
/**
 * SOURCE Card @ squareup/bills/tender.proto at 836:3
 */
CardTender.Card = $root.lookupType('squareup.bills.CardTender.Card');
fixType(CardTender.Card);
Builder.createAndAttachToType(CardTender.Card);
/**
 * SOURCE Brand @ squareup/bills/tender.proto at 837:5
 */
CardTender.Card.Brand = $root.lookupEnum('squareup.bills.CardTender.Card.Brand').values;
/**
 * Indicates if register fell back to swiping or manual entry for EMV cards.
 * If this is not set to NONE, entry_method will be expected to be SWIPED or KEYED
 *
 * TECHNICAL: the card's chip has failed multiple times and the reader must fall back to swipe/keyed data.
 *
 * SCHEME: the reader failed to read the EMV chip's Application ID and must fall back to swipe/keyed data.
 *
 * SELLER_SWIPE_EMV_CARD_OPT_IN: the merchant has opted in to swiping chip cards. This is a value set on the server, but it exists on the client version for read-only purposes.
 *
 * SOURCE ChipCardFallbackIndicator @ squareup/bills/tender.proto at 900:5
 */
CardTender.Card.ChipCardFallbackIndicator = $root.lookupEnum('squareup.bills.CardTender.Card.ChipCardFallbackIndicator').values;
/**
 * SOURCE FelicaBrand @ squareup/bills/tender.proto at 922:5
 */
CardTender.Card.FelicaBrand = $root.lookupEnum('squareup.bills.CardTender.Card.FelicaBrand').values;
/**
 * SOURCE CardCoBrand @ squareup/bills/tender.proto at 949:5
 */
CardTender.Card.CardCoBrand = $root.lookupEnum('squareup.bills.CardTender.Card.CardCoBrand').values;
/**
 * SOURCE DelayCapture @ squareup/bills/tender.proto at 964:3
 */
CardTender.DelayCapture = $root.lookupType('squareup.bills.CardTender.DelayCapture');
fixType(CardTender.DelayCapture);
Builder.createAndAttachToType(CardTender.DelayCapture);
/**
 * SOURCE Reason @ squareup/bills/tender.proto at 965:5
 */
CardTender.DelayCapture.Reason = $root.lookupEnum('squareup.bills.CardTender.DelayCapture.Reason').values;
/**
 * SOURCE Authorization @ squareup/bills/tender.proto at 994:3
 */
CardTender.Authorization = $root.lookupType('squareup.bills.CardTender.Authorization');
fixType(CardTender.Authorization);
Builder.createAndAttachToType(CardTender.Authorization);
/**
 * SOURCE DeclineReason @ squareup/bills/tender.proto at 1011:5
 */
CardTender.Authorization.DeclineReason = $root.lookupEnum('squareup.bills.CardTender.Authorization.DeclineReason').values;
/**
 * Details a server hint for signature on the client. This will only be passed
 * down for successfully authorized card tenders and should be respected by the
 * client. The value of this field should be OR'd with the existing client logic
 * for signature.
 *
 * SOURCE SignatureBehavior @ squareup/bills/tender.proto at 1025:5
 */
CardTender.Authorization.SignatureBehavior = $root.lookupEnum('squareup.bills.CardTender.Authorization.SignatureBehavior').values;
/**
 * SOURCE Emv @ squareup/bills/tender.proto at 1044:3
 */
CardTender.Emv = $root.lookupType('squareup.bills.CardTender.Emv');
fixType(CardTender.Emv);
Builder.createAndAttachToType(CardTender.Emv);
/**
 * The kind of processing that has already been performed for this transaction. The
 * current application for this field is to indicate when an EMV transaction has been
 * offline-processed by the reader.
 *
 * SOURCE ProcessingType @ squareup/bills/tender.proto at 1059:5
 */
CardTender.Emv.ProcessingType = $root.lookupEnum('squareup.bills.CardTender.Emv.ProcessingType').values;
/**
 * SOURCE CardholderVerificationMethod @ squareup/bills/tender.proto at 1107:5
 */
CardTender.Emv.CardholderVerificationMethod = $root.lookupEnum('squareup.bills.CardTender.Emv.CardholderVerificationMethod').values;
/**
 * Which account should we draw money from.
 *
 * SOURCE AccountType @ squareup/bills/tender.proto at 1161:3
 */
CardTender.AccountType = $root.lookupEnum('squareup.bills.CardTender.AccountType').values;
/**
 * SOURCE SettlementDetails @ squareup/bills/tender.proto at 1172:3
 */
CardTender.SettlementDetails = $root.lookupType('squareup.bills.CardTender.SettlementDetails');
fixType(CardTender.SettlementDetails);
Builder.createAndAttachToType(CardTender.SettlementDetails);
/**
 * SOURCE OtherTender @ squareup/bills/tender.proto at 1186:1
 */
export const OtherTender = $root.lookupType('squareup.bills.OtherTender');
fixType(OtherTender);
Builder.createAndAttachToType(OtherTender);
/**
 * Must map to the definitions in config/other_tenders.yml in SQ/Web.
 *
 * SOURCE OtherTenderType @ squareup/bills/tender.proto at 1188:3
 */
OtherTender.OtherTenderType = $root.lookupEnum('squareup.bills.OtherTender.OtherTenderType').values;
/**
 * ExternalMetadata is an optional field for square merchants to provide custom/other tender information
 * used by large seller / retail
 *
 * SOURCE ExternalMetadata @ squareup/bills/tender.proto at 1230:1
 */
export const ExternalMetadata = $root.lookupType('squareup.bills.ExternalMetadata');
fixType(ExternalMetadata);
Builder.createAndAttachToType(ExternalMetadata);
/**
 * Deprecated tenders or tenders that the client will not recognize.
 *
 * SOURCE GenericTender @ squareup/bills/tender.proto at 1238:1
 */
export const GenericTender = $root.lookupType('squareup.bills.GenericTender');
fixType(GenericTender);
Builder.createAndAttachToType(GenericTender);
/**
 * SOURCE NoSaleTender @ squareup/bills/tender.proto at 1243:1
 */
export const NoSaleTender = $root.lookupType('squareup.bills.NoSaleTender');
fixType(NoSaleTender);
Builder.createAndAttachToType(NoSaleTender);
/**
 * SOURCE CashTender @ squareup/bills/tender.proto at 1250:1
 */
export const CashTender = $root.lookupType('squareup.bills.CashTender');
fixType(CashTender);
Builder.createAndAttachToType(CashTender);
/**
 * SOURCE Amounts @ squareup/bills/tender.proto at 1251:3
 */
CashTender.Amounts = $root.lookupType('squareup.bills.CashTender.Amounts');
fixType(CashTender.Amounts);
Builder.createAndAttachToType(CashTender.Amounts);
/**
 * SOURCE WalletTender @ squareup/bills/tender.proto at 1263:1
 */
export const WalletTender = $root.lookupType('squareup.bills.WalletTender');
fixType(WalletTender);
Builder.createAndAttachToType(WalletTender);
/**
 * SOURCE ZeroAmountTender @ squareup/bills/tender.proto at 1267:1
 */
export const ZeroAmountTender = $root.lookupType('squareup.bills.ZeroAmountTender');
fixType(ZeroAmountTender);
Builder.createAndAttachToType(ZeroAmountTender);
/**
 * Tender that moves money between a Square bank account and another bank account.
 *
 * SOURCE BankTransferTender @ squareup/bills/tender.proto at 1275:1
 */
export const BankTransferTender = $root.lookupType('squareup.bills.BankTransferTender');
fixType(BankTransferTender);
Builder.createAndAttachToType(BankTransferTender);
/**
 * Identifier for a counterparty bank account. Exactly one field must be set.
 *
 * SOURCE CounterpartyBankAccount @ squareup/bills/tender.proto at 1280:3
 */
BankTransferTender.CounterpartyBankAccount = $root.lookupType('squareup.bills.BankTransferTender.CounterpartyBankAccount');
fixType(BankTransferTender.CounterpartyBankAccount);
Builder.createAndAttachToType(BankTransferTender.CounterpartyBankAccount);
/**
 * Details about the bank transfer tender.
 * SentState, FailedState, or none will be set, dependng on the state of the tender.
 *
 * SOURCE TenderStateDetail @ squareup/bills/tender.proto at 1312:3
 */
BankTransferTender.TenderStateDetail = $root.lookupType('squareup.bills.BankTransferTender.TenderStateDetail');
fixType(BankTransferTender.TenderStateDetail);
Builder.createAndAttachToType(BankTransferTender.TenderStateDetail);
/**
 * Used to differentiate between ACH (BANK_ACCOUNT) and credit transfers (e.g. SEPA/FPS) (BANK_TRANSFER).
 *
 * SOURCE Type @ squareup/bills/tender.proto at 1327:3
 */
BankTransferTender.Type = $root.lookupEnum('squareup.bills.BankTransferTender.Type').values;
/**
 * SquareCapitalTender is used to represent a tender funded by Square Capital.
 *
 * SOURCE SquareCapitalTender @ squareup/bills/tender.proto at 1338:1
 */
export const SquareCapitalTender = $root.lookupType('squareup.bills.SquareCapitalTender');
fixType(SquareCapitalTender);
Builder.createAndAttachToType(SquareCapitalTender);
/**
 * SOURCE CardInstrumentDetails @ squareup/bills/tender.proto at 1339:3
 */
SquareCapitalTender.CardInstrumentDetails = $root.lookupType('squareup.bills.SquareCapitalTender.CardInstrumentDetails');
fixType(SquareCapitalTender.CardInstrumentDetails, {
  instrumentToken: {
    notEmpty: true
  },
  card: {
    required: true
  }
});
Builder.createAndAttachToType(SquareCapitalTender.CardInstrumentDetails);
/**
 * A payment taken + processed by an external integration (eg. Caviar) recorded in Square
 *
 * SOURCE ExternalTender @ squareup/bills/tender.proto at 1361:1
 */
export const ExternalTender = $root.lookupType('squareup.bills.ExternalTender');
fixType(ExternalTender);
Builder.createAndAttachToType(ExternalTender);
/**
 * SOURCE PaymentSource @ squareup/bills/tender.proto at 1362:3
 */
ExternalTender.PaymentSource = $root.lookupType('squareup.bills.ExternalTender.PaymentSource');
fixType(ExternalTender.PaymentSource);
Builder.createAndAttachToType(ExternalTender.PaymentSource);
/**
 * A tender where the buyer pushes money to the seller.
 *
 * SOURCE PushTender @ squareup/bills/tender.proto at 1384:1
 */
export const PushTender = $root.lookupType('squareup.bills.PushTender');
fixType(PushTender);
Builder.createAndAttachToType(PushTender);
/**
 * Using Square Cash App to pay.
 *
 * SOURCE CashAppTender @ squareup/bills/tender.proto at 1412:1
 */
export const CashAppTender = $root.lookupType('squareup.bills.CashAppTender');
fixType(CashAppTender);
Builder.createAndAttachToType(CashAppTender);
/**
 * Tender for Alipay
 *
 * SOURCE AlipayTender @ squareup/bills/tender.proto at 1434:1
 */
export const AlipayTender = $root.lookupType('squareup.bills.AlipayTender');
fixType(AlipayTender);
Builder.createAndAttachToType(AlipayTender);
/**
 * Tender for PayPay
 *
 * SOURCE PaypayTender @ squareup/bills/tender.proto at 1450:1
 */
export const PaypayTender = $root.lookupType('squareup.bills.PaypayTender');
fixType(PaypayTender);
Builder.createAndAttachToType(PaypayTender);
/**
 * Tender for Rakuten Pay
 *
 * SOURCE RakutenPayTender @ squareup/bills/tender.proto at 1464:1
 */
export const RakutenPayTender = $root.lookupType('squareup.bills.RakutenPayTender');
fixType(RakutenPayTender);
Builder.createAndAttachToType(RakutenPayTender);
/**
 * Tender for Au Pay
 *
 * SOURCE AuPayTender @ squareup/bills/tender.proto at 1473:1
 */
export const AuPayTender = $root.lookupType('squareup.bills.AuPayTender');
fixType(AuPayTender);
Builder.createAndAttachToType(AuPayTender);
/**
 * Tender for D Barai
 *
 * SOURCE DBaraiTender @ squareup/bills/tender.proto at 1482:1
 */
export const DBaraiTender = $root.lookupType('squareup.bills.DBaraiTender');
fixType(DBaraiTender);
Builder.createAndAttachToType(DBaraiTender);
/**
 * Tender for Merpay Pay
 *
 * SOURCE MerpayTender @ squareup/bills/tender.proto at 1491:1
 */
export const MerpayTender = $root.lookupType('squareup.bills.MerpayTender');
fixType(MerpayTender);
Builder.createAndAttachToType(MerpayTender);
/**
 * Tender for Wechat Pay
 *
 * SOURCE WechatPayTender @ squareup/bills/tender.proto at 1500:1
 */
export const WechatPayTender = $root.lookupType('squareup.bills.WechatPayTender');
fixType(WechatPayTender);
Builder.createAndAttachToType(WechatPayTender);
/**
 * Tender for Local Cash (Neighborhoods).
 *
 * SOURCE LocalCashTender @ squareup/bills/tender.proto at 1509:1
 */
export const LocalCashTender = $root.lookupType('squareup.bills.LocalCashTender');
fixType(LocalCashTender);
Builder.createAndAttachToType(LocalCashTender);
/**
 * Tender for Afterpay
 *
 * SOURCE AfterpayTender @ squareup/bills/tender.proto at 1518:1
 */
export const AfterpayTender = $root.lookupType('squareup.bills.AfterpayTender');
fixType(AfterpayTender);
Builder.createAndAttachToType(AfterpayTender);
/**
 * Tender for House Account
 *
 * SOURCE SquareAccountTender @ squareup/bills/tender.proto at 1538:1
 */
export const SquareAccountTender = $root.lookupType('squareup.bills.SquareAccountTender');
fixType(SquareAccountTender);
Builder.createAndAttachToType(SquareAccountTender);